export default "<!-- Vue HTML Markup -->\n\n<template>\n  <v-select\n    :items=\"['Foo', 'Bar']\"\n    label=\"Items\"\n  ></v-select>\n</template>\n";